export enum StakingContractType {
  STANDARD = 'standard',
  FLEXIBLE = 'flexible',
  NEGATIVE = 'negative',
  PERIODICAL = 'periodical',
  WHITELISTED = 'whitelisted',
  VIP = 'vip',
  NONE = 'none',
}
